import {Component, OnDestroy, OnInit} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {Store} from "@ngrx/store";
import {
  Config,
  getConfig,
  getEditingBusinessUnit,
  getLookups,
  getSelectedBusinessUnit,
  initialConfigState,
  initialLookupsState,
  Lookups,
  toggleLoading
} from "../../../redux";
import {BusinessUnitService} from "../../services";
import {IBusinessUnit, IBusinessUnitAdminSettings} from "../../models";
import {FormControl, FormGroup} from "@angular/forms";
import {HttpErrorResponse} from "@angular/common/http";
import {MAT_DATE_FORMATS} from "@angular/material/core";
import {MY_DATE_FORMATS} from "../../../ng-material/ng-material.module";
import {Subscription} from "rxjs";
import {ConfirmationModalComponent, UserCardModalComponent, UserCardSize} from "../../../shared/components";
import {ModalSize, UtilService} from "../../../shared/services/util/util.service";
import {MatDialog} from "@angular/material/dialog";
import { LookupService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-business-unit-info',
  templateUrl: './business-unit-info.component.html',
  styleUrls: ['./business-unit-info.component.scss'],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS}
  ]
})
export class BusinessUnitInfoComponent implements OnInit, OnDestroy {
  employees: any[] = [];
  userCardSize = UserCardSize;

  userForm = new FormGroup({
    slug: new FormControl('', []),
    displayName: new FormControl('', []),
    internalName: new FormControl('', []),
    businessUnitId: new FormControl('', []),
    businessUnitType: new FormControl({value: '', disabled: true}, []),
    kycStatus: new FormControl('', []),
    domicile: new FormControl('', []),
    subType: new FormControl('', []),
    status: new FormControl('', []),
    intakeDescription: new FormControl('', []),
    legalEntityDomicile: new FormControl('', []),
    representative: new FormControl(),
    profileLink: new FormControl({value: '', disabled: true}),
    imageUrl: new FormControl()
  });

  adminForm = new FormGroup({
    businessUnitId: new FormControl(),
    relationshipStartDate: new FormControl(new Date(), []),
    accreditationPassed: new FormControl(false, []),
    globalNdaSigned: new FormControl('', []),
    workflowStatus: new FormControl('', []),
    attestationSignedComments: new FormControl('', [])
  });

  // adminBusinessUnit: IBusinessUnit = {} as unknown as IBusinessUnit;
  // selectedBusinessUnit: IBusinessUnit = {} as unknown as IBusinessUnit;

  constructor(
    private businessUnitService: BusinessUnitService,
    private toastr: ToastrService,
    private dataService: DataService,
    private store: Store,
    public util: UtilService,
    private dialog: MatDialog,
    public lookupService: LookupService
  ) {
    // this.config$ = this.store.select(getConfig).subscribe((config: Config) => {
    //   this.config = config;
    // });

  }

  ngOnInit() {
    this.fetchRondeivuEmployeesUsers();
    this.fetchBusinessUnitAdminSettings();
    this.fetchBusinessUnitInfo();
  }

  ngOnDestroy() {
  }


  fetchBusinessUnitInfo() {
    var selectedBuid = this.dataService.adminSelectedBusinessUnitId;

    if (!selectedBuid) {
      this.toastr.error("No business unit selected!", $localize`:@@companyName:Rondeivu`);
      return;
    }

    this.businessUnitService.getBusinessUnit(selectedBuid).subscribe({
      next: (bu) => {
        this.userForm.patchValue(bu);
        // The whole representative is returned on the response but only id is required
        if (!!bu && !!bu.representative) {
          this.userForm.get('representative')?.setValue(bu.representative.id);
        }

      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error("Unable to get business unit information!", $localize`:@@companyName:Rondeivu`);
      }
    })
  }

  fetchBusinessUnitAdminSettings() {
    var selectedBuid = this.dataService.adminSelectedBusinessUnitId;

    if (!selectedBuid) {
      this.toastr.error("No business unit selected!", $localize`:@@companyName:Rondeivu`);
      return;
    }

    this.businessUnitService.getBusinessUnitAdminSettings(selectedBuid).subscribe({
      next: (adminSettings: IBusinessUnitAdminSettings) => {
        this.adminForm.patchValue(adminSettings);
      }
    });
  }

  fetchRondeivuEmployeesUsers() {
    this.businessUnitService.getRondeivuEmployees().subscribe({
      next: (rondeivuEmployees: any[]) => {
        this.employees = rondeivuEmployees;
      }
    });
  }

  save() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.businessUnitService.editBusinessUnit(this.userForm.value as IBusinessUnit).subscribe({
      next: (emp: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("Business Unit Information Saved!", $localize`:@@companyName:Rondeivu`);
      }, error: (error: HttpErrorResponse) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to save business unit information!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  adminSave() {
    var selectedBuid = this.dataService.adminSelectedBusinessUnitId;

    if (!selectedBuid) {
      this.toastr.error("No business unit selected!", $localize`:@@companyName:Rondeivu`);
      return;
    }
    this.store.dispatch(toggleLoading({loading: true}));
    this.businessUnitService.editBusinessUnitAdminSettings(selectedBuid, this.adminForm.getRawValue()).subscribe(emp => {
      this.store.dispatch(toggleLoading({loading: false}));
      this.toastr.success("Admin Settings Saved!", $localize`:@@companyName:Rondeivu`);
    }, (error: HttpErrorResponse) => {
      this.store.dispatch(toggleLoading({loading: false}));
      this.toastr.error("Unable to save admin settings!", $localize`:@@companyName:Rondeivu`);
    });
  }

  openImageUploadModal() {
    this.dialog.open(UserCardModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog closed!");
      if (!!result) {
        const id = this.userForm.get('businessUnitId')?.value || '';
        const file = new File([result], 'user.png');
        this.businessUnitService.uploadBusinessUnitImage(file, id).subscribe({
          next: (res: any) => {
            let url = res.url || ''
            this.userForm.get('imageUrl')?.setValue(url);
            this.toastr.success("Image Uploaded! ", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.toastr.error("Something went wrong! " + err.message);
          }
        });
      }
    });
  }

  clearImage() {
    this.dialog.open(ConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      disableClose: true,
      data: {}
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog closed!");
      if (!!result) {
        const id = this.userForm.get('businessUnitId')?.value || '';
        this.businessUnitService.clearBusinessUnitImage(id).subscribe({
          next: (res: any) => {
            let url = res.url || ''
            this.userForm.get('imageUrl')?.setValue(url);
            this.toastr.success("Image Cleared! ", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.toastr.error("Something went wrong! " + err.message);
          }
        });
      }
    });
  }

}
